import React, { Component } from "react";
import { element } from "prop-types";
import IntlMessages from "util/IntlMessages";

const BusinessTypes = ({ businesstypes, handleTypeChange, businessTypeId }) => (
  // <div className="row">
  //   <div className=" col-12">
  //     <ul className="type-parent">
    <ul className="list-inline text-center" id="salon-types-list">
        <li
            className={`list-inline-item ${businessTypeId === 0 ? "active" : ""}`}
            key={0}
          >
            <a onClick={event => handleTypeChange(event, 0)} href="javascript:;">
              All
            </a>
          </li>
        {businesstypes.map((element, index) => (
          <li
            className={`list-inline-item ${element._id === businessTypeId ? "active" : ""}`}
            key={element._id}
          >
            <a onClick={event => handleTypeChange(event, element._id)} href="javascript:;">
              {element.name}
            </a>
          </li>
        ))}
    </ul>
  //     </ul>
  //   </div>
  // </div>
);

export default BusinessTypes;



// WEBPACK FOOTER //
// ./components/BusinessTypes/index.js